import { Injectable } from '@angular/core';

import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Biosecurity_protocol } from '../models/biosecurity_protocol';

import { AppSettings } from '../app.settings';

@Injectable({
  providedIn: 'root'
})
export class BiosecurityProtocolService {

  constructor(private http: HttpClient) { }

  get(id: string): Promise<Biosecurity_protocol> {
  	return this.getWithRest('id/' + id);
  }

  getForVenue(venue_id: string): Promise<Biosecurity_protocol> {
    return this.getWithRest('venue_id/' + venue_id);
  }

  private getWithRest(rest_url: string) : Promise<Biosecurity_protocol> {
    return new Promise((resolve, reject) => {
    return this.http.get(AppSettings.API_ENDPOINT + 'biosecurity_protocols/' + rest_url).subscribe((response:any) => {

      if(response.type == 'biosecurity_protocol' && response.data){
        resolve(response.data);
      } else {
        console.log(response);
        reject(response);
      }

    },
      error_response => {
            if(error_response instanceof HttpErrorResponse){
              if(error_response.status == 404){
                resolve(new Biosecurity_protocol({id: "",
                              venue_id: "",
                              protocol_text: ""}))
              }
            }
            reject(error_response);
      });
  });
  }

}
